import { getRuntimeTheme } from '../runtimeEnv'
import { citadelTheme } from './citadelTheme'
import { kelownaTheme } from './kelownaTheme'
import { pittmeadowsTheme } from './pittmeadowsTheme'
import { princegeorgeTheme } from './princegeorgeTheme'
import { kamloopsTheme } from './kamloopsTheme'
import { saskatoonTheme } from './saskatoonTheme'

const THEME = getRuntimeTheme()

const themeMapping = {
  kelownapir: { ...kelownaTheme },
  citadel: { ...citadelTheme },
  citadelpir: { ...citadelTheme },
  citadelfoi: { ...citadelTheme },
  pittmeadowspir: { ...pittmeadowsTheme },
  pittmeadowsfoi: { ...pittmeadowsTheme },
  princegeorgefoi: { ...princegeorgeTheme },
  kamloopsfoi: { ...kamloopsTheme },
  saskatoonfoi: { ...saskatoonTheme },
  saskatoonpir: { ...saskatoonTheme }
}

export const theme = themeMapping[THEME]
